<div class="apps-container">
  <div class="apps-header">
    <h2>Apps</h2>

    <button mat-raised-button color="accent" (click)="newApiAccessPopup('new')">New</button>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="applications" class="apps-table">
      <ng-container matColumnDef="APPLICATIONNAME">
        <!-- <th mat-header-cell *matHeaderCellDef>Name</th> -->
        <td mat-cell *matCellDef="let app">
          {{ app.APPLICATIONNAME }}
        </td>
      </ng-container>

      <ng-container matColumnDef="APPLICATIONDESCRIPTION">
        <!-- <th mat-header-cell *matHeaderCellDef>Description</th> -->
        <td mat-cell *matCellDef="let app">
          {{ app.APPLICATIONDESCRIPTION }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CLIENTID">
        <!-- <th mat-header-cell *matHeaderCellDef>Client Id</th> -->
        <td mat-cell *matCellDef="let app">
          {{ app.CLIENTID }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CREATEDATUTC">
        <!-- <th mat-header-cell *matHeaderCellDef>Created Date</th> -->
        <td mat-cell *matCellDef="let app">
          {{ app.CREATEDATUTC | date: 'dd/MM/yyyy hh:mm a' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ACTION">
        <!-- <th mat-header-cell *matHeaderCellDef></th> -->

        <td mat-cell *matCellDef="let app">
          <div class="action-buttons">
            <button
              mat-icon-button
              color="primary"
              (click)="newApiAccessPopup('edit', app); $event.stopPropagation()"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              mat-icon-button
              color="warn"
              (click)="deleteApiAccessPopup(app); $event.stopPropagation()"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->

      <tr
        mat-row
        *matRowDef="let row; let index = index; columns: displayedColumns"
        (click)="ApiAppsValueGet(row, index)"
        [style.background]="highlightedRows() === row.APPLICATIONGUID ? selectedColore() : ''"
        [ngClass]="highlightedRows() === row.APPLICATIONGUID ? 'row-text-colore' : ''"
      ></tr>
    </table>
  </div>

  <mat-card class="app-details-card" *ngIf="ApiValuGetData">
    <h2>Application Details</h2>

    <div class="details-grid">
      <div class="detail-item">
        <label>Name</label>
        <div class="detail-value">{{ ApiValuGetData.APPLICATIONNAME || '-' }}</div>
      </div>

      <div class="detail-item">
        <label>Active</label>
        <div class="detail-value">
          <mat-slide-toggle [checked]="ApiValuGetData.ISACTIVE" disabled></mat-slide-toggle>
        </div>
      </div>

      <div class="detail-item">
        <label>Description</label>
        <div class="detail-value">
          {{ ApiValuGetData.APPLICATIONDESCRIPTION || '-' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Public App</label>
        <div class="detail-value">
          <mat-slide-toggle
            [checked]="ApiValuGetData.ALLOWPUBLICCLIENT"
            disabled
          ></mat-slide-toggle>
        </div>
      </div>

      <div class="detail-item">
        <label>Client ID</label>
        <div class="detail-value copy-text">
          {{ ApiValuGetData.CLIENTID || '-' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Created</label>
        <div class="detail-value">
          {{ ApiValuGetData.CREATEDATUTC | date: 'dd/MM/yyyy hh:mm a' }}
        </div>
      </div>

      <div class="detail-item">
        <label>API Key</label>
        <div class="detail-value copy-text api-key-value">
          <span>
            {{
              showApiKey
                ? ApiValuGetData.APIGATEWAYAPIKEY
                : maskApiKey(ApiValuGetData.APIGATEWAYAPIKEY)
            }}
          </span>

          <button
            type="button"
            class="api-key-action"
            (click)="copyApiKey()"
            matTooltip="Copy API Key"
          >
            <mat-icon>file_copy</mat-icon>
          </button>

          <button
            type="button"
            class="api-key-action"
            (click)="showApiKey = !showApiKey"
            [matTooltip]="showApiKey ? 'Hide API Key' : 'Reveal API Key'"
          >
            <mat-icon>
              {{ showApiKey ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </div>
      </div>

      <div class="detail-item">
        <label>Last Modified</label>
        <div class="detail-value">
          {{ ApiValuGetData.LASTMODIFIEDUTC | date: 'dd/MM/yyyy hh:mm a' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Redirect URL 1</label>
        <div class="detail-value copy-text">
          {{ ApiValuGetData.REDIRECTURL || '-' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Credentials Expire</label>
        <div class="detail-value">
          {{ ApiValuGetData.CLIENTCREDENTIALEXPIRESUTC | date: 'dd/MM/yyyy hh:mm a' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Redirect URL 2</label>
        <div class="detail-value copy-text">
          {{ ApiValuGetData.REDIRECTURL2 || '-' }}
        </div>
      </div>

      <div class="detail-item">
        <label>Redirect URL 3</label>
        <div class="detail-value copy-text">
          {{ ApiValuGetData.REDIRECTURL3 || '-' }}
        </div>
      </div>
    </div>
  </mat-card>
</div>
